import React from 'react';
import { connect } from 'react-redux';
import { Tooltip, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { CREDITS, DEFAULT_PLUGIN_PREVIEW, ONE_TIME_ACTIVATION_PLUGIN, VERIFIED_BADGE } from '../../config/media';

const exchangeType = {
    basic: 'Basic',
    crypto: 'Crypto Pro',
    fiat: 'Enterprise',
    boost: 'Boost',
};

const PluginContents = (props) => {

    const { pluginData, isVisible, setIsVisible, activatePlugin } = props;

    const isActivated = activatePlugin.some((val) => val.name === pluginData.name)

    const {
        author,
        free_for,
        only_for,
    } = pluginData;

    return (
        <div className="d-flex plugin-detail-content-wrapper">
            <img
                src={
                    pluginData && pluginData.icon
                        ? pluginData.icon
                        : DEFAULT_PLUGIN_PREVIEW
                }
                alt="Plugin"
                className='plugin-detail-icon'
            />
            <div className="plugin-container">
                <div className="plugin-content-wrapper">
                    <div className="title-wrapper d-flex">
                        {' '}
                        <p className='header'>{isVisible && <span className='text-white sub-header'>Name:</span>}{pluginData.name}</p>{' '}
                        {pluginData && pluginData.price > 0 && isVisible && (
                            <div>
                                <div className='vertical-divider'></div>
                            </div>
                        )}
                        <p className='version-content'><span className='sub-header'>Version:</span>{pluginData.version}</p>{' '}
                    </div>
                    <p><span className='text-white sub-header'>Description:</span>{pluginData.description}</p>
                    <div className='d-flex'>
                        {' '}
                        {free_for && !!free_for.length ? (
                            <>
                                <p className='text-white'>Note:</p>{' '}
                                <div className='info-circle'>
                                    <InfoCircleOutlined />
                                </div>{' '}
                                {free_for && free_for.map((item, inx) => (
                                    <p>{`${inx === 0 ? '' : `, `} ${exchangeType[item]
                                        }`}</p>
                                ))}
                            </>
                        ) : (
                            ''
                        )}{' '}
                    </div>
                    <p className="tooltip-container text-white d-flex">Author: <p className='d-flex'>

                        {author === 'HollaEx' ? (
                            <div className='verify-badge-wrapper'>
                                <Tooltip
                                    placement="rightBottom"
                                    title={`Verified plugin by ${author}`}
                                ><img alt='verify-badge' className='verify-badge-icon' src={VERIFIED_BADGE}></img>
                                </Tooltip>
                            </div>
                        ) : null}{' '}
                        {pluginData.author}
                    </p></p>
                    <p>
                        {' '}
                        {pluginData.payment_type &&
                            pluginData.payment_type === 'one-time' ? (
                            <>
                                <span className='text-white sub-header'>Type:</span>
                                <img
                                    src={ONE_TIME_ACTIVATION_PLUGIN}
                                    className='one-time-activation-icon'
                                    alt='one-time-activation-icon'
                                />{' '}
                                {pluginData.payment_type}
                            </>
                        ) : pluginData.payment_type === 'credits' ? (
                            <>
                                <span className='text-white sub-header'>Type:</span>
                                <img src={CREDITS}
                                    className='one-time-activation-icon'
                                    alt='credits'
                                />{' '}
                                {pluginData.payment_type}
                            </>
                        ) : (
                            ''
                        )}{' '}
                    </p>
                    {only_for && only_for.length ? (
                        <div className='d-flex'>
                            <p className="text-white sub-header">Only For: </p>
                            {only_for && only_for.map((item, inx) => (
                                <p>{`${inx === 0 ? '' : `, `} ${exchangeType[item]}`}</p>
                            ))}
                        </div>
                    ) : null}
                    {free_for && free_for.length ? (
                        <div className='d-flex'>
                            <p className="text-white sub-header">Free For: </p>{' '}
                            {free_for && free_for.map((item, inx) => (
                                <p>{` ${inx === 0 ? '' : `, `} ${exchangeType[item]}`}</p>
                            ))}
                        </div>
                    ) : null}
                    {<div className='d-flex'>
                        <p className='text-white sub-header'>Price: </p>{' '}
                        <p className='custom-free'>
                            {' '}
                            {pluginData.payment_type === 'free'
                                ? 'Free'
                                : `$ ${pluginData.price}`}
                        </p>
                    </div>
                    }
                    {(isActivated || pluginData.price === 0) &&
                        <div>
                            <p>✓ Activated plugins</p>
                            <p>(Go to your live exchange to install this plugin)</p>
                        </div>
                    }
                    {(!isVisible && pluginData.price > 0 && pluginData.payment_type === "one-time") &&
                        <div>
                            <Button className='render-btn' type='primary' onClick={() => setIsVisible(true)}>Buy</Button>
                        </div>}
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = (store) => {
    return {
        pluginData: store.plugin.pluginData,
        activatePlugin: store.plugin.activatedPlugin
    }
}

export default connect(mapStateToProps)(PluginContents);
